import React, { useContext } from "react";
import Img from "@/components/img";
import { MenuContext } from "@/context/menu-context";
import { navigate } from '@reach/router';

const isBrowser = typeof window !== "undefined"

const BlogSidebar = ({ news, categories, tags, tagsAreLinks, setCategory }) => {
  const { contextTagFilter, setcontextTagFilter } = useContext(MenuContext);

  const handleTagFilter = (clickedTag) => {
    if (!contextTagFilter.includes(clickedTag)) {
      setcontextTagFilter([...contextTagFilter, clickedTag])
    }
    else setcontextTagFilter(contextTagFilter.filter((tag) => tag !== clickedTag));
  }

  const navToCategory = (categoryName) => {
    navigate(`/blog?searchCategorie=${categoryName}`)
    if (setCategory) setCategory(categoryName)
  }

  return (
    <div id='sidebar' className="blog_details_right">
      <div className="blog_right_box mb-30 hideOnMobile">
        <div className="tagcloud">
          <h2>Filtrar por etiquetas</h2>
          <ul>
            {tags?.map((tag) =>
              <li key={`tag-${tag.name}`}>
                <span onKeyDown={() => null} role='button' tabIndex={0} className={`border rounded-pill px-3 mx-1 ${contextTagFilter?.includes(tag.name) ? 'active' : ''}`} onClick={!tagsAreLinks ? () => handleTagFilter(tag.name) : isBrowser ? ()=> {window.location.href = `/blog?searchTag=${tag.name}` } : ()=>null }>{tag.name}</span>
            </li>
            )}
          

          </ul>
        </div>
      </div>
      <div className="blog_right_box mb-30 ">
        <div className="latest_post">
          <h2>Últimas Novedades</h2>
          <ul>
            {news?.slice(0, 3).map((newsItem => 
              <li key={`newsitem-${newsItem.title}`}>
              <a href={newsItem.detailPage}>
                <div className="img-block">
                    <Img src={newsItem.img} alt="post 1" className="img-fluid" />
                </div>
                  {newsItem.title}
              </a>
            </li>
           ))}


          </ul>
        </div>
      </div>
      <div className="blog_right_box mb-30">
        <div className="widget_categories">
          <h2>Categorías</h2>
          <ul>
            {categories?.map((categorie) =>
              <li key={`categorie-${categorie.name}`}>
                <span onKeyDown={() => null} role='button' tabIndex={0} onClick={() => { navToCategory(categorie.name)  }} > {categorie.name}<i className="fa fa-angle-right"></i></span>         

            </li>
            )}

          </ul>
        </div>
      </div>

    </div>
  );
};

export default BlogSidebar;
